import * as React from "react";
import { Card, Text, makeStyles, tokens } from "@fluentui/react-components";
import {
  ErrorCircle24Regular,
  ArrowSync24Regular,
  CheckmarkCircle24Regular,
  ArrowSyncCircle48Regular,
  ErrorCircle48Regular,
  CheckmarkCircle48Regular,
  ArrowSyncCircle32Regular,
  ArrowSyncCircleRegular,
} from "@fluentui/react-icons";
import { useTypographyStyles } from "../../../styles/typography.styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    gap: tokens.spacingHorizontalXL,
    flexWrap: "wrap",
  },
  card: {
    padding: tokens.spacingVerticalM,
    display: "flex",
    flexDirection: "row",
    gap: tokens.spacingHorizontalS,
    alignItems: "center",
    flex: "1 1 auto",
    cursor: "pointer",
    transition: "transform 0.1s ease, box-shadow 0.1s ease",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: tokens.shadow8,
    },
    ":active": {
      transform: "translateY(0)",
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
  },
  openIcon: {
    backgroundColor: "#ededf0ff",
    color: "#5b6e7f",
  },
  activeIcon: {
    backgroundColor: "#E1F5FE",
    color: "#008fd2",
  },
  resolvedIcon: {
    backgroundColor: "#E8F5E9",
    color: "#009966",
  },
  icon: {
    width: "32px",
    height: "32px"
  }
});

interface DiscussionStatisticsProps {
  openCount: number;
  inProgressCount: number;
  resolvedCount: number;
  onStatusClick: (status: string) => void;
}

const DiscussionStatistics: React.FC<DiscussionStatisticsProps> = ({
  openCount,
  inProgressCount,
  resolvedCount,
  onStatusClick,
}) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  return (
    <div className={styles.container}>
      <Card className={styles.card} onClick={() => onStatusClick("open")}>
        <div className={`${styles.iconContainer} ${styles.openIcon}`}>
          <ErrorCircle48Regular className={styles.icon} />
        </div>
        <Text className={typography.statNumber}>{openCount}</Text>
        <Text className={typography.statLabel}>Open</Text>
      </Card>

      <Card className={styles.card} onClick={() => onStatusClick("in_progress")}>
        <div className={`${styles.iconContainer} ${styles.activeIcon}`}>
          <ArrowSyncCircle48Regular className={styles.icon} />
        </div>
        <Text className={typography.statNumber}>{inProgressCount}</Text>
        <Text className={typography.statLabel}>In Progress</Text>
      </Card>

      <Card className={styles.card} onClick={() => onStatusClick("closed")}>
        <div className={`${styles.iconContainer} ${styles.resolvedIcon}`}>
          <CheckmarkCircle48Regular className={styles.icon} />
        </div>
        <Text className={typography.statNumber}>{resolvedCount}</Text>
        <Text className={typography.statLabel}>Resolved</Text>
      </Card>
    </div>
  );
};

export default DiscussionStatistics;
